import axios from 'axios';
axios.defaults.baseURL = 'https://pablo-mendoza.cyclic.app';
export default axios;
